import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthServiceUser } from './auth.service';
import { LocalStorageService } from '../local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardCheck implements CanActivate {
    constructor(private authService: AuthServiceUser, private router: Router,
        private localStorage: LocalStorageService) { }

    canActivate(): boolean {
        console.log("cvv ", this.authService.isUserAuthenticated());
        if (this.authService.isUserAuthenticated()) {
            if (this.localStorage.getItem('firstMenu')) {
                this.router.navigateByUrl(this.localStorage.getItem('firstMenu'));
            } else {
                this.router.navigateByUrl('/product/all');
            }
        }

        return true;
    }
}
